import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepIconDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 23,
	viewBox: "0 0 26 23",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 1H4C2.34315 1 1 2.34315 1 4V19C1 20.6569 2.34315 22 4 22H22C23.6569 22 25 20.6569 25 19V4C25 2.34315 23.6569 1 22 1ZM4 0C1.79086 0 0 1.79086 0 4V19C0 21.2091 1.79086 23 4 23H22C24.2091 23 26 21.2091 26 19V4C26 1.79086 24.2091 0 22 0H4Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 6.5H5V5.5H20V6.5ZM13 9.5H5V8.5H13V9.5ZM20 9.5H16V8.5H20V9.5ZM11 12.5H5V11.5H11V12.5ZM18 12.5H12V11.5H18V12.5ZM19 14.5V15.5H5V14.5H19ZM21 17.5V18.5H5V17.5H21Z"
	})]
});
export default SvgStepIconDocuments;
